import { Context, Effect, Layer, Option, Schema } from 'effect'

const SameSitePolicy = Schema.Literals(['strict', 'lax', 'none'])

export class SetCookieOptions extends Schema.Class<SetCookieOptions>(
  'SetCookieOptions',
)({
  expires: Schema.Date.pipe(Schema.optionalKey),
  maxAge: Schema.Number.pipe(Schema.optionalKey),
  path: Schema.String.pipe(Schema.optionalKey),
  domain: Schema.String.pipe(Schema.optionalKey),
  secure: Schema.Boolean.pipe(Schema.optionalKey),
  httpOnly: Schema.Boolean.pipe(Schema.optionalKey),
  sameSite: SameSitePolicy.pipe(Schema.optionalKey),
  partitioned: Schema.Boolean.pipe(Schema.optionalKey),
}) {}

export const CookieKey = Schema.Literals([
  'discord_oauth_state',
  'discord_code_verifier',
  'session',
  'supabase_token',
  'theme',
])

export type CookieKey = typeof CookieKey.Type

export interface CookieStoreShape {
  get(name: CookieKey): Effect.Effect<Option.Option<string>>
  set(
    name: CookieKey,
    value: string,
    options: SetCookieOptions,
  ): Effect.Effect<void>
  delete(name: CookieKey): Effect.Effect<void>
}

export class CookieStore extends Context.Service<
  CookieStore,
  CookieStoreShape
>()('CookieStore') {
  static forTest(initialCookies?: Map<string, string>) {
    const cookies = new Map<string, string>(initialCookies)
    return Layer.succeed(
      this,
      CookieStore.of({
        get: (name: CookieKey) =>
          Effect.succeed(Option.fromNullishOr(cookies.get(name))),
        set: (name: CookieKey, value: string) =>
          Effect.sync(() => cookies.set(name, value)),
        delete: (name: CookieKey) => Effect.sync(() => cookies.delete(name)),
      }),
    )
  }
}
